import { AppError, AppErrorBuilder } from '@h5s/util-error';

const LOGOUT_IN_PROGRESS = 'LOGOUT_IN_PROGRESS';

export function buildLogoutInProgressError(): AppError {
  return new AppErrorBuilder('Logout in progress').addInfo('code', LOGOUT_IN_PROGRESS).build();
}

export function isLogoutInProgressError(error: Error): boolean {
  return error instanceof AppError && error.info.get('code') === LOGOUT_IN_PROGRESS;
}
